/* template */
<template><div class="popup-warp"><div :class="(popupClass)" class="popup"><div class="title">专属礼包已到账</div><mpx-view @scroll="scroll" class="coupon-list"><div v-for="(item, index) in (couponList)" :key="item.index" class="coupon"><div class="left"><coupon-price :couponInfo="(item.coupon)" type="popup-result"/></div><div class="right"><div class="info"><div class="name">{{item.coupon.name}}</div><div class="usage-limit" v-if="(item.coupon.usage_limit)">{{item.coupon.usage_limit}}</div><div class="valid-period" v-if="(item.coupon.valid_period)">{{item.coupon.valid_period}}</div></div></div></div></mpx-view><div class="footer"><mpx-image :class='("arrow-icon "+(showMoreArrow ? "is-visible" : ""))' src="https://ut-static.udache.com/webx/ut/obhYNk1zIRZYShrz_riyh.png" mode="widthFix" v-if="(popupClass === 'is-more-3')"/><mpx-button @tap.stop="click" class="btn">{{btnText}}</mpx-button></div><mpx-image @tap="close" src="https://ut-static.udache.com/webx/ut/OjikVXhZn2VJCZ7wpHInt.png" mode="widthFix" class="icon-close"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md411932a"}'>
.popup-warp
  z-index 99
  width 100%
  height 100%
  position fixed
  top: 0
  left 0
  background-color: rgba(0,0,0,.85)
  display: flex;
  justify-content: center;
  align-items center
  .icon-close
    padding 16rpx
    width 40rpx
    position absolute
    left 50%
    bottom -120rpx
    transform translate(-50%)
  .popup
    position relative
    box-sizing border-box
    padding-top 184rpx
    top -5%
    width 626rpx
    height 683rpx
    background-image: url(https://ut-static.udache.com/webx/ut/Qk3iLujX5dHRxAwXP8oGr.png)
    background-size cover
    &.is-more-2
      height 900rpx
      background-image url(https://ut-static.udache.com/webx/ut/1BlI3rZCQaodbU4jjvhNI.png)
    &.is-more-3
      height 949rpx
      background-image url(https://ut-static.udache.com/webx/ut/sAYW0BpU0qkjXlnUxp_9p.png)
      .coupon-list
        height 540rpx
        padding-bottom 90rpx
      .footer
        height 300rpx
        background-image url(https://ut-static.udache.com/webx/ut/RPFv8VNZrMlxvWQduJnpG.png)
    .coupon-list
      height 380rpx
      padding 0 33rpx
      box-sizing: border-box;
      overflow-y auto
      margin 0 auto
      &::-webkit-scrollbar
        display: none;
      .coupon
        width 562rpx
        height 162rpx
        background-image: url('https://ut-static.udache.com/webx/ut/VI9M7XXgvUg2mENCvOOoP.png')
        background-size cover
        display flex
        padding 8rpx 20rpx 8rpx 16rpx
        box-sizing border-box
        & +.coupon
          margin-top 25rpx
        .left
          flex 1
          position relative
        .right
          width 300rpx
          box-sizing border-box
          display flex
          align-items: center;
          .info
            flex: 1;
            margin-left 44rpx
            .name
              font-size: 32rpx;
              font-family: PingFang SC;
              font-weight: 600;
              color: #B14536;
              text-shadow: 1px 1px 0px #FFFFFF;
              margin-bottom 18rpx
              line-height 1
            .usage-limit, .valid-period
              font-size: 17rpx;
              font-family: PingFang SC;
              font-weight: 400;
              color: #848484;
              line-height 1.3
    .icon-arrow
      z-index 4
      width 42rpx
      position: absolute;
      bottom: 267rpx;
      left 50%
      transform translateX(-50%)
    .footer-image
      z-index 2
      width: 610rpx
      position: absolute;
      bottom: 0;
    .title
      text-align center
      letter-spacing: 0;
      margin-bottom 25rpx
      font-size: 33rpx;
      font-family: PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      background: linear-gradient(179deg, #FFFEFB 0%, #FFF2B4 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    .footer
      background-image url(https://ut-static.udache.com/webx/ut/3SM8L7ej6dlUSkcm1dJE0.png)
      background-size cover
      width 100%
      height 270rpx
      position absolute
      bottom 0
      left 0
      text-align center
      .arrow-icon
        width 33rpx
        margin-top 45rpx
        transition opacity 0.5s
        opacity 0
        &.is-visible
          opacity 1
    .btn
      z-index 9
      position absolute
      bottom 47rpx
      left 50%
      background-image: url(https://ut-static.udache.com/webx/ut/jETYAhdwBorgAcLqLc4rM.png)
      background-size: cover
      width 512rpx
      height 121rpx
      line-height 121rpx
      text-align center
      transform translate(-50%)
      font-family: PingFang SC;
      font-size: 51rpx;
      font-weight: bold;
      color: #E34F49;
      background-color: transparent;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md411932a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./popup-result.mpx.js?isComponent&outputPath=components%2Fpopup-resultd411932a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./popup-result.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fpopup-resultd411932a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["md411932a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/popup-resultd411932a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-price':getComponent(require("../common/coupon-price.mpx?isComponent&outputPath=components%2Fcoupon-price9261a862%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
